module.exports = __webpack_public_path__ + "images/selected.642ac3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/store/shopping/selected.png
// module id = dyDK
// module chunks = 19